import { FrequencyUnit, HabitSchedule } from '@griply/types';

import { Frequency, RRule } from './lib/rrule';

export const getScheduleFrequency = (schedule: HabitSchedule) => {
  if (schedule.frequency) {
    return schedule.frequency.unit;
  }

  // A stored schedule can hold neither a frequency nor an rrule; the converter passes that through, and the week is
  // the frequency the rest of the code assumes for a schedule it cannot read.
  if (!schedule.rrule?.format) {
    return FrequencyUnit.Week;
  }

  const rrule = RRule.fromString(schedule.rrule.format);
  switch (rrule.options.freq) {
    case Frequency.YEARLY:
      return FrequencyUnit.Year;
    case Frequency.MONTHLY:
      return FrequencyUnit.Month;
    default:
      return FrequencyUnit.Week;
  }
};
